export enum EntityEventType {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
  DELETE = 'DELETE',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface EntityEvent<T> {
  old: T | null;
  new: T | null;
  topic: string;
  username: string;
  channel: 'REDIS_PUB_SUB' | 'PULSAR';
  eventType: EntityEventType;
  receivedTimestamp: number;
}

export interface CreateEvent<T> extends EntityEvent<T> {
  old: null;
  new: T;
}

export interface ModifyEvent<T> extends EntityEvent<T> {
  old: T;
  new: T;
}

export interface DeleteEvent<T> extends EntityEvent<T> {
  old: T;
  new: null;
}
